import React from 'react';

import { savePostAuthRedirect } from '../services/postAuthRedirect';
import { clearSignupCouponCode } from '../services/signupCoupon';

interface AuthButtonsProps {
  onLogin: () => void;
  onSignUp: () => void;
}

/*
 * Real links, not buttons: with JavaScript disabled the prerendered pages
 * navigate to /login and /signup (standalone prerendered auth pages). With
 * JavaScript on, the click is intercepted - the URL still changes (so the
 * modal is shareable/back-button friendly) but the underlying page stays
 * and the auth modal opens in place. Navbar restores the URL on close.
 *
 * The post-auth redirect is saved BEFORE pushState overwrites the URL with
 * the auth path, so a successful login returns to the page the user was on.
 */
const openInPlace = (path: string, open: () => void) => (e: React.MouseEvent) => {
  e.preventDefault();
  savePostAuthRedirect();
  if (path === '/signup') clearSignupCouponCode();
  window.history.pushState({ authModal: true }, '', path);
  open();
};

export const AuthButtons: React.FC<AuthButtonsProps> = ({ onLogin, onSignUp }) => (
  <div className="auth-buttons">
    <a className="btn btn-outline" href="/login" onClick={openInPlace('/login', onLogin)}>
      Log in
    </a>
    <a className="btn btn-outline" href="/signup" onClick={openInPlace('/signup', onSignUp)}>
      Sign up for free
    </a>
  </div>
);
